import defaultPrimary from '../default/primary';

const dark = (params) => defaultPrimary(params);

export default dark;
